import script from "./LogEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./LogEvent.vue?vue&type=script&setup=true&lang=js"

import "./LogEvent.vue?vue&type=style&index=0&id=70df96ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70df96ca"]])

export default __exports__